export const colors = {
  vader: {
    50: "#FFD1DD",
    100: "#FFAFB2",
    200: "#FF7176",
    300: "#FF385C",
    400: "#E31D40",
    500: "#BF1538",
    600: "#9B0222",
    700: "#6D0A1E",
    800: "#4B0A17",
    900: "#330000",
  },
  sentinel: {
    50: "#FFD9B2",
    100: "#FFA473",
    200: "#FF7731",
    300: "#FF4C00",
    400: "#DF3603",
    500: "#C12D00",
    600: "#872A0F",
    700: "#6C2413",
    800: "#4E210D",
    900: "#401602",
  },
  rey: {
    50: "#FDE776",
    100: "#FDD600",
    200: "#EEC000",
    300: "#D6AE00",
    400: "#8D7425",
    500: "#6F5B00",
    600: "#534700",
    700: "#433800",
    800: "#362B06",
    900: "#272300",
  },
  yoda: {
    50: "#C7F08E",
    100: "#B4E051",
    200: "#8BD111",
    300: "#6EB41D",
    400: "#4B8510",
    500: "#2D660A",
    600: "#175717",
    700: "#104806",
    800: "#0C3308",
    900: "#0B2708",
  },
  kenobi: {
    50: "#A7FAE6",
    100: "#6DEDD7",
    200: "#41D6C3",
    300: "#00B4A0",
    400: "#008673",
    500: "#006F5F",
    600: "#005A4B",
    700: "#014D40",
    800: "#053B2E",
    900: "#032B2B",
  },
  luke: {
    50: "#C0E6FF",
    100: "#7BC7FF",
    200: "#5AAAFA",
    300: "#3992D9",
    400: "#337AB3",
    500: "#1E5789",
    600: "#00436A",
    700: "#033358",
    800: "#0C2C40",
    900: "#01012C",
  },
  windu: {
    50: "#EDD1FF",
    100: "#D7AAFF",
    200: "#BA8EF7",
    300: "#AE6DE7",
    400: "#9754D3",
    500: "#734097",
    600: "#552E71",
    700: "#412255",
    800: "#311A41",
    900: "#1E0231",
  },
  sabine: {
    50: "#FFD1FF",
    100: "#FF9DED",
    200: "#FF71D3",
    300: "#FF3BA0",
    400: "#E82A70",
    500: "#BD1E59",
    600: "#93083B",
    700: "#6C0129",
    800: "#430019",
    900: "#260F20",
  },
  stormtrooper: {
    50: "#E8E8E8",
    100: "#C7C7C7",
    200: "#ADADAD",
    300: "#949494",
    400: "#747574",
    500: "#5A5A5A",
    600: "#484848",
    700: "#363636",
    800: "#242424",
    900: "#1A1A1A",
  },
  snowtrooper: {
    50: "#E4EBEB",
    100: "#C7D1D1",
    200: "#ADB7B7",
    300: "#949E9E",
    400: "#6D7777",
    500: "#576264",
    600: "#3B4545",
    700: "#2D3737",
    800: "#162424",
    900: "#041922",
  },
  dunetrooper: {
    50: "#E9E0E0",
    100: "#D0C7C7",
    200: "#B7ADAD",
    300: "#9D9494",
    400: "#7D7373",
    500: "#645A5A",
    600: "#504545",
    700: "#3B3131",
    800: "#2B2022",
    900: "#1F1517",
  },
  ahsoka: {
    50: "#FEFEFE",
    100: "#F9F9F9",
    200: "#F3F3F3",
    300: "#ECECEC",
    400: "#DBDBDB",
    500: "#D0CECE",
    600: "#BEBEBE",
    700: "#AFAFAF",
    800: "#A3A3A3",
    900: "#989797",
  },
  brand: {
    1: "#242424",
    2: "#E82A70",
  },
  ui: {
    1: "#FEFEFE",
    2: "#F3F3F3",
    3: "#E4EBEB",
    4: "#949E9E",
    5: "#576264",
  },
  text: {
    1: "#484848",
    2: "#747574",
    3: "#FDFDFD",
    4: "#1A1A1A",
  },
  hover: {
    primary: "#E82A70",
    primaryText: "#BD1E59",
    secondary: "#FF9DED",
    row: "#C7D1D1",
  },
  support: {
    1: "#BF1538",
    2: "#4B8510",
    3: "#EEC000",
    4: "#5AAAFA",
  }
};
